import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BookedTrip } from '@ibe/models';
import { AbstractModalContentComponent } from '../../common/modal/abstract-modal-content.component';
import { ModalService } from '../../common/modal/modal.indra.service';

@Component({
	selector: 'app-ancillary-discard-modal',
	templateUrl: './ancillary-discard-modal.indra.component.html',
	styleUrls: ['./ancillary-discard-modal.component.scss']
})
export class INDRAAncillaryDiscardModalComponent extends AbstractModalContentComponent implements OnInit {

	constructor(protected modalService: ModalService, private router: Router) {
		super(modalService);
		this.TYPE = 'dialog';
	}

	ngOnInit() {
	}

	goToPayment() {
		const booking: BookedTrip = this.data[1];
		this.closeModal();
		window.scrollTo(0, 0);
		this.router.navigate(['my-bookings/purchase', booking.pnr]);
	}

	discardExtras() {
		const option: any = this.data[0];
		const booking: BookedTrip = this.data[1];

		this.closeModal();

		// Reset all extras
		booking.flights.forEach((flight) => {
			return flight.passengerInfo.forEach((pass) => {

				const newInfo = {
					boughtSeat: null,
					added_bags: [],
					loungeEnabled: false,
					fastTrackEnabled: false,
					specialMeals: null,
					sportsEquipment: [],
					pets: [],
					musicInstruments: []
				};
				const stops = pass.stops.map(info => Object.assign({}, info, newInfo));
			});
		});

		this.router.navigate([option.link], {
			queryParams: option.queryParams
		});
	}
}
